var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from "react";
import { useCommonDataContext } from "../../utils/useCommonDataContext";
// To add a new field all you need to do is create a React.FC with props extends CustomDataFieldProps
export var createField = function createField(component) {
  return function (context, path) {
    return function CreateComponent(props) {
      // Expected that types infer is not correct
      var Component = component;
      var name = props.name,
        disabled = props.disabled,
        rest = __rest(props, ["name", "disabled"]);
      var _useCommonDataContext = useCommonDataContext(context, path, name, disabled),
        isDisabled = _useCommonDataContext.disabled,
        onChange = _useCommonDataContext.onChange,
        value = _useCommonDataContext.value,
        isCompact = _useCommonDataContext.compact,
        validatorResults = _useCommonDataContext.validatorResults;
      return /*#__PURE__*/React.createElement(Component, Object.assign({}, rest, {
        validatorResults: validatorResults,
        compact: isCompact,
        value: value,
        name: name,
        onChange: onChange,
        disabled: isDisabled
      }));
    };
  };
};